<template>
    <div class="boxShow">
        <div :class="isMobile?'mainBoxs':'mainBox'">
            <span class="bTitle">会员风采展示</span>
            <div class="swiperBox">
                <swiper :options="swiperOption" ref="mySwiper" class="swiperShow" v-if="swiperList.length">
                    <swiper-slide v-for="(item,index) in swiperList" :key="index" :class="item.url?'curp':''">
                       <div>
                            <img :src="item.img" style="width: 100%;height: 180px;" />
                            <p>{{item.dwname}}</p>
                            <p class="overh2 c66 mt5">{{ item.dwjianjie }}</p>
                       </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    var vm = null
    export default{
        created(){
            vm =this
        },
        components: {
            swiper,
            swiperSlide
        },
        data(){
            return{
                swiperList:[],
                swiperOption: {
                    loop: true,
                    slidesPerView: 3,
                    spaceBetween:35,
                    autoplay: {
                        delay: 3000, // 自动切换时间间隔为3000毫秒（3秒）
                        disableOnInteraction: false // 是否在用户操作后停止自动播放
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    on:{
                        click:function(){
                            let initIndex = this.clickedIndex - this.activeIndex + this.realIndex
                            let index = initIndex === vm.swiperList.length ? 0 : initIndex
                            vm.toNoticeDetail(index)
                        }
                    }
                }
            }
        },
        methods:{
            // 获取会员数据
            getMemberInfo(){
                this.Request({
                    url: '/api/NewsData/GetNewsimg',
                    method: 'get',
                }).then((data) => {
                   this.swiperList = data.Data
                })
            },
            toNoticeDetail(index){
                if(this.swiperList[index].url){
                    window.open(this.swiperList[index].url,'_blank')
                }
            }
        },
        mounted(){
            this.getMemberInfo()
        }
    }
</script>

<style scoped>
    .boxShow{
        width: 100%;
        margin-top: 20px;
        margin-bottom: 40px;
    }
    .mainBox{
        width: 1400px;
        margin: 0 auto;
        padding: 20px;
        background-color: #fff;
    }
    .mainBoxs{
        width: 100%;
        padding: 20px;
        background-color: #fff;
    }
    .bTitle{
        font-size: 20px;
        font-weight: bold;
        padding-bottom: 10px;
        color: #0d69f0;
        border-bottom: 2px solid #0d69f0;
    }
    .swiperBox{
        width: 100%;
        height: 300px;
        margin-top: 20px;
    }
    .swiperBoxs{
        width: 100%;
        margin-top: 40px;
    }
    .swiperShow{
        width: 83%;
        height: 300px;
        margin: 0 auto;
        margin-top: 20px;
    }
    .swiper-button-next,.swiper-button-prev{
        border: 1px solid #007aff;
        width: 44px;
        border-radius: 5px;
        background-size: 27px 27px;
    }
    .swiper-button-next{
        /* background-size: 80% 100%; */
        right: 30px;
    }
    .swiper-button-prev{
        /* background-size: 80% 100%; */
        left: 30px;
    }
</style>